import React from 'react';
import { mergeClassNames } from '../../../../../utils';
import Button from '../..';
import CloseIcon from './assets/close_16.svg';
import CloseIconBig from './assets/close_24.svg';
import styles from './index.module.scss';

export function CloseButton({
  clickHandler,
  isBig = false,
  title = null,
  tabIndex = null,
  children = null,
  className = null,
  style = null,
  disabled = null,
  isIconRight = false,
}) {
  const icon = isBig ? <CloseIconBig /> : <CloseIcon className={styles.icon} />;
  const iconProp = isIconRight ? { endIcon: icon } : { startIcon: icon };

  return (
    <Button
      disabled={disabled}
      title={title}
      tabIndex={tabIndex}
      clickHandler={clickHandler}
      className={mergeClassNames([styles.button, className])}
      style={style}
      {...iconProp}
    >
      {children}
    </Button>
  );
}
